function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP pick up in-store delivery method
 * 
 */
import React from 'react';
import { connect } from 'react-redux';
import ClubStore from '../club-store/ClubStore';
import './DeliveryMethodPickUpInStore.scss';
import ErrorMessage from '../error-message/ErrorMessage';
import ClubStoresMap from '../club-stores-map/ClubStoresMap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faFileAlt, faSpinner, faTrash, faCheck } from '@fortawesome/free-solid-svg-icons';
import { deliveryPickupPerson, consentForm, consentFormError, consentFormRequiredAttribute } from '../../actions';
import { API, OPTIONS } from '../../data/Data';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ALLOWED_FILE_TYPES = ['application/pdf', 'image/jpeg', 'image/png'];
const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

export class DeliveryMethodPickUpInStore extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "fileInputRef", void 0);
    _defineProperty(this, "handlePickupPersonChange", value => {
      this.props.dispatch(deliveryPickupPerson(value));
      this.props.dispatch(consentFormRequiredAttribute(value === 'other'));
      // Clear consent form when switching back to "self"
      if (value === 'self') {
        this.props.dispatch(consentForm('', ''));
      }
    });
    _defineProperty(this, "handleUploadClick", () => {
      if (this.fileInputRef.current) {
        this.fileInputRef.current.click();
      }
    });
    _defineProperty(this, "handleFileChange", event => {
      const file = event.target.files[0];
      if (!file) return;

      // Validate file type
      if (!ALLOWED_FILE_TYPES.includes(file.type)) {
        this.props.dispatch(consentFormError(true, 'Invalid file type. Please upload a PDF, JPG, or PNG file.'));
        return;
      }

      // Validate file size
      if (file.size > MAX_FILE_SIZE) {
        this.props.dispatch(consentFormError(true, 'File is too large. Maximum size is 10MB.'));
        return;
      }
      this.uploadFile(file);
    });
    _defineProperty(this, "uploadFile", file => {
      const {
        application
      } = this.props;
      const {
        submission_token,
        id
      } = application;
      const url = `${API}/${id}/third-party-pickup-form`;
      const formData = new FormData();
      formData.append('submission_token', submission_token);
      formData.append('file', file, file.name);

      // fetch sets the right headers when passed a FormData object as `body:`
      // eslint-disable-next-line no-unused-vars
      let {
        headers,
        ...options
      } = OPTIONS;
      options = {
        ...options,
        body: formData
      };
      this.setState({
        uploading: true
      });
      fetch(url, options).then(async response => {
        const result = await response.json();
        if (response.status === 400) {
          throw new Error(result.message || 'Order already submitted or invalid submission token.');
        }
        if (response.status === 422) {
          throw new Error(result.message || 'Validation error. Please check the file and try again.');
        }
        if (!response.ok) {
          throw new Error(result.message || 'Error uploading file. Please try again.');
        }
        return result;
      }).then(result => {
        this.setState({
          uploading: false
        });
        if (result.success) {
          this.props.dispatch(consentForm('uploaded', result.filename));
        }
      }).catch(err => {
        this.setState({
          uploading: false
        });
        this.props.dispatch(consentFormError(true, err.message));
      });
    });
    _defineProperty(this, "handleRemoveFile", () => {
      this.props.dispatch(consentForm('', ''));
      // Reset file input
      if (this.fileInputRef.current) {
        this.fileInputRef.current.value = '';
      }
    });
    this.fileInputRef = /*#__PURE__*/React.createRef();
    this.state = {
      uploading: false
    };
  }
  render() {
    const {
      clubStores,
      deliveryPickUpStore,
      deliveryPickupPerson,
      consentForm
    } = this.props;
    let storeErrorMessage = deliveryPickUpStore.error ? 'A store must be selected.' : '';
    let pickupPersonErrorMessage = deliveryPickupPerson.error ? 'A pickup option must be selected.' : '';
    let consentFormErrorMessage = consentForm.error ? consentForm.errorMessage : '';
    if (clubStores && clubStores.length === 1) {
      deliveryPickUpStore.value = clubStores[0].id;
    }
    return /*#__PURE__*/_jsxs("div", {
      id: "store-selector",
      className: "form-element-container DeliveryMethodPickUpInStore",
      children: [/*#__PURE__*/_jsx("div", {
        className: "label title",
        children: "Select a store:"
      }), /*#__PURE__*/_jsxs("div", {
        className: "club-store-selector",
        children: [/*#__PURE__*/_jsx("div", {
          className: "radio-buttons",
          children: (clubStores || []).map(clubStore => /*#__PURE__*/_jsx(ClubStore, {
            clubStore: clubStore
          }, clubStore.id))
        }), /*#__PURE__*/_jsx(ClubStoresMap, {
          clubStores: clubStores
        }), /*#__PURE__*/_jsx(ErrorMessage, {
          message: storeErrorMessage,
          error: deliveryPickUpStore.error
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "pickup-person-selector",
        children: [/*#__PURE__*/_jsx("div", {
          className: "label title",
          children: "Select a pickup option:"
        }), /*#__PURE__*/_jsxs("div", {
          className: "radio-buttons",
          children: [/*#__PURE__*/_jsxs("div", {
            className: 'radiobutton-container pickup-option' + (deliveryPickupPerson.value === 'self' ? ' highlight' : ''),
            tabIndex: "0",
            onFocus: () => this.handlePickupPersonChange('self'),
            children: [/*#__PURE__*/_jsx("input", {
              id: "pickupPerson-self",
              className: "radio-button-hidden",
              type: "radio",
              name: "pickupPerson",
              value: "self",
              checked: deliveryPickupPerson.value === 'self',
              onChange: () => this.handlePickupPersonChange('self')
            }), /*#__PURE__*/_jsxs("label", {
              htmlFor: "pickupPerson-self",
              children: [/*#__PURE__*/_jsx("div", {
                className: "radio-display",
                children: /*#__PURE__*/_jsx("div", {
                  className: 'inner' + (deliveryPickupPerson.value === 'self' ? ' highlight' : '')
                })
              }), /*#__PURE__*/_jsx("span", {
                children: "I will pick up my IDP at the selected store."
              })]
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: 'radiobutton-container pickup-option' + (deliveryPickupPerson.value === 'other' ? ' highlight' : ''),
            tabIndex: "0",
            onFocus: () => this.handlePickupPersonChange('other'),
            children: [/*#__PURE__*/_jsx("input", {
              id: "pickupPerson-other",
              className: "radio-button-hidden",
              type: "radio",
              name: "pickupPerson",
              value: "other",
              checked: deliveryPickupPerson.value === 'other',
              onChange: () => this.handlePickupPersonChange('other')
            }), /*#__PURE__*/_jsxs("label", {
              htmlFor: "pickupPerson-other",
              children: [/*#__PURE__*/_jsx("div", {
                className: "radio-display",
                children: /*#__PURE__*/_jsx("div", {
                  className: 'inner' + (deliveryPickupPerson.value === 'other' ? ' highlight' : '')
                })
              }), /*#__PURE__*/_jsx("span", {
                children: "Someone else will pick up my IDP at the selected store."
              })]
            })]
          })]
        }), /*#__PURE__*/_jsx(ErrorMessage, {
          message: pickupPersonErrorMessage,
          error: deliveryPickupPerson.error
        }), deliveryPickupPerson.value === 'other' && /*#__PURE__*/_jsxs("div", {
          className: "third-party-consent-form",
          children: [/*#__PURE__*/_jsxs("p", {
            children: ["Please download the ", /*#__PURE__*/_jsx("a", {
              href: "https://www.aaa.asn.au/third-party-pickup",
              target: "_blank",
              rel: "noopener noreferrer",
              children: "Third-party Pickup Consent Form"
            }), ", fill it out and sign it."]
          }), /*#__PURE__*/_jsxs("a", {
            className: "button reverse",
            href: "https://www.aaa.asn.au/third-party-pickup",
            download: true,
            target: "_blank",
            rel: "noopener noreferrer",
            children: [/*#__PURE__*/_jsx("span", {
              className: "icon",
              children: /*#__PURE__*/_jsx(FontAwesomeIcon, {
                icon: faDownload
              })
            }), /*#__PURE__*/_jsx("span", {
              className: "text",
              children: "Download form"
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "consent-form-upload",
            children: [/*#__PURE__*/_jsx("p", {
              children: "Once you have completed the form with your signature, you can upload it here."
            }), /*#__PURE__*/_jsx("input", {
              type: "file",
              ref: this.fileInputRef,
              onChange: this.handleFileChange,
              accept: ".pdf,.jpg,.jpeg,.png",
              style: {
                display: 'none'
              }
            }), consentForm.value ? /*#__PURE__*/_jsxs("div", {
              className: "uploaded-file-info",
              children: [/*#__PURE__*/_jsx("span", {
                className: "success-icon",
                children: /*#__PURE__*/_jsx(FontAwesomeIcon, {
                  icon: faCheck
                })
              }), /*#__PURE__*/_jsx("span", {
                className: "file-name",
                children: consentForm.fileName
              }), /*#__PURE__*/_jsxs("button", {
                type: "button",
                className: "button reverse remove-file",
                onClick: this.handleRemoveFile,
                children: [/*#__PURE__*/_jsx("span", {
                  className: "icon",
                  children: /*#__PURE__*/_jsx(FontAwesomeIcon, {
                    icon: faTrash
                  })
                }), /*#__PURE__*/_jsx("span", {
                  className: "text",
                  children: "Remove"
                })]
              })]
            }) : /*#__PURE__*/_jsxs(React.Fragment, {
              children: [/*#__PURE__*/_jsxs("button", {
                type: "button",
                className: "button reverse",
                onClick: this.handleUploadClick,
                disabled: this.state.uploading,
                children: [/*#__PURE__*/_jsx("span", {
                  className: "icon",
                  children: /*#__PURE__*/_jsx(FontAwesomeIcon, {
                    icon: this.state.uploading ? faSpinner : faFileAlt,
                    spin: this.state.uploading
                  })
                }), /*#__PURE__*/_jsx("span", {
                  className: "text",
                  children: this.state.uploading ? 'Uploading...' : 'Upload form'
                })]
              }), /*#__PURE__*/_jsx("p", {
                className: "allowed-types",
                children: "Allowed file types: PDF, JPG, PNG."
              })]
            }), /*#__PURE__*/_jsx(ErrorMessage, {
              message: consentFormErrorMessage,
              error: consentForm.error
            })]
          })]
        })]
      })]
    });
  }
}
const mapStateToProps = ({
  application,
  deliveryPickUpStore,
  deliveryPickupPerson,
  consentForm
}) => {
  return {
    application,
    deliveryPickUpStore,
    deliveryPickupPerson,
    consentForm
  };
};
const VisibleDeliveryMethodPickUpInStore = connect(mapStateToProps)(DeliveryMethodPickUpInStore);
export default VisibleDeliveryMethodPickUpInStore;